import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocationCityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"location_city"}/>
}
